// Hook custom per filtrare immagini valide
// Nota per il prossimo sviluppatore:
// - Controlla se gli URL delle immagini restituiscono status 200 tramite HEAD request
// - Restituisce solo le immagini "valide"
// - Utile per gallerie di proprietà o preview immagini

import { useState, useEffect } from 'react';
import { ImageDetail } from '../components/Property/Gallery/types';

const useValidImages = (images: ImageDetail[]): ImageDetail[] => {
    const [validImages, setValidImages] = useState<ImageDetail[]>([]);

    // Funzione helper per verificare se un'immagine esiste
    const isValidImageUrl = async (url: string | null): Promise<boolean> => {
        if (!url) return false;
        try {
            const response = await fetch(url, { method: 'HEAD' });
            return response.ok;
        } catch (error) {
            console.warn(`Errore nel controllare l'URL ${url}:`, error);
            return false;
        }
    };

    useEffect(() => {
        // Filtra solo le immagini valide
        const filterValid = async () => {
            const results: boolean[] = await Promise.all(images.map(img => isValidImageUrl(img.urlBig)));
            const filteredImages = images.filter((_, index) => results[index]);
            setValidImages(filteredImages);
        };
        filterValid();
    }, [images]); // Rilancia il controllo quando cambia l'array di immagini

    return validImages;
};

export default useValidImages;